import { StopOutlined } from '@ant-design/icons'
import { Button, Input, Modal, Popconfirm } from 'antd'
import React, { useState } from 'react'
import { $t } from '~/i18n.js'
import { AlertTag } from '../atom/AlertTag.jsx'
import { DayChecklistModal } from '../days/DayChecklistModal.jsx'

export const CloseDay = ({ dag_id, canOpen, canClose, updateStatus, getFlights, activeDay, disabled }) => {
  const [savingStatus, setSavingStatus] = useState(false)

  const [showConfirm, setConfirm] = useState(false)
  const [confirmText, setConfirmText] = useState('')
  const [showEndChecklist, setShowEndChecklist] = useState(false)
  const [pendingCloseData, setPendingCloseData] = useState(null)

  const sluitMsg = $t('sluit dag')

  const forceClose = (invalidFlights, confirm) => {
    Modal.confirm({
      title: $t('Er zijn ongeldige vluchten gevonden'),
      icon: <StopOutlined />,
      content: <div>
        <p>{$t('De volgende vluchten bevatten fouten: ')}</p>
        <div style={{ maxHeight: 150, overflowY: 'auto' }}>
          {invalidFlights.map((t, idx) => <p key={idx}>{t}</p>)}
        </div>
      </div>,
      okText: $t('Sluit dag'),
      okType: 'danger',
      cancelText: $t('Terug'),
      onCancel () {
        return getFlights({ dag_id })
      },
      onOk () {
        return confirm()
      }
    })
  }

  const triggerUpdateStatus = async (data) => {
    setSavingStatus(true)
    const newDay = await updateStatus({ ...data, dag_id })

    if (newDay && newDay.endChecklistIncomplete) {
      // Backend guard: show end checklist interactively
      setPendingCloseData({ ...data, force_checklist: true })
      setShowEndChecklist(true)
    } else if (newDay && newDay.invalidFlights) {
      forceClose(newDay.invalidFlights, () => setConfirm(true))
    } else {
      await getFlights({ dag_id })
    }

    setSavingStatus(false)
  }

  return (
    <>

      {showEndChecklist && (
        <DayChecklistModal
          visible={showEndChecklist}
          type="end"
          items={activeDay?.checklist_end || []}
          dagId={dag_id}
          onClose={() => {
            setShowEndChecklist(false)
            setPendingCloseData(null)
          }}
          onComplete={async () => {
            setShowEndChecklist(false)
            if (pendingCloseData) {
              await triggerUpdateStatus(pendingCloseData)
              setPendingCloseData(null)
            }
          }}
          readOnly={false}
        />
      )}

      <Modal
        title={$t('Bevestig')}
        open={showConfirm}
        confirmLoading={savingStatus}
        onCancel={() => {
          setConfirm(false)
          setConfirmText('')
        }}
        onOk={
             async () => {
               await triggerUpdateStatus({ action: 'closed', force: true })
               setConfirm(false)
               setConfirmText('')
               await getFlights({ dag_id })
             }
           }
        okButtonProps={{ disabled: confirmText !== sluitMsg }}
      >

        <div className='column'>

          <p><AlertTag/> {$t('je gaat de dag afsluiten terwijl er ongeldige vluchten zijn gevonden')}.</p>

          <p>{$t('Om te bevestigen dat je dit bewust doet, schrijf')} <span className='bold'>{sluitMsg}</span> {$t('in het input hieronder')}.</p>

          <Input
            type='text' style={{ width: 150, margin: '10px auto' }} placeholder={sluitMsg}
            value={confirmText}
            onChange={(elm) => setConfirmText(elm.target.value)}
          />

        </div>
      </Modal>

      {canClose && (
        <Popconfirm
          placement='bottom' title={$t('Zeker weten dat je de dag wilt afsluiten?')}
          onConfirm={() => {
            const endItems = activeDay?.checklist_end || []
            const hasUnanswered = endItems.some(
              (item) => item.required && (item.value === null || item.value === undefined)
            )
            if (hasUnanswered) {
              setPendingCloseData({ action: 'closed', force: false })
              setShowEndChecklist(true)
            } else {
              triggerUpdateStatus({ action: 'closed', force: false })
            }
          }}
          okText={$t('Ja')} cancelText={$t('Nee')}
        >
          <Button disabled={disabled} size='small' icon={<StopOutlined />} loading={savingStatus} style={{ marginLeft: 6 }}>
            {$t('Afsluiten')}
          </Button>
        </Popconfirm>
      )}

      {canOpen && (
        <Popconfirm
          placement='bottom' title={$t('Zeker weten dat je de dag wilt openen?')}
          onConfirm={() => triggerUpdateStatus({ action: 'open' })}
          okText={$t('Ja')} cancelText={$t('Nee')}
        >
          <Button size='small' loading={savingStatus} style={{ marginLeft: 6 }} disabled={disabled} >
            {$t('Heropen')}
          </Button>
        </Popconfirm>
      )}
    </>
  )
}
